import React, { useEffect, useState } from 'react';
import {useLocation} from 'react-router-dom';

interface RotatingWordsProps {
  words: string[];
  interval?: number;
}

const RotatingWords: React.FC<RotatingWordsProps> = ({ 
  words, 
  interval = 3000 
}) => {
  const [currentWordIndex, setCurrentWordIndex] = useState(0);
  const location=useLocation();
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentWordIndex((prev) => (prev + 1) % words.length);
    }, interval);
    return () => clearInterval(timer);
  }, [words.length, interval]);

  return (
    <div className={location.pathname.includes("search") ? "animated-placeholder-updated" : "animated-placeholder"}>
      {words.map((word, index) => (
        <span 
          key={word} 
          className={`rotating-text ${index === currentWordIndex ? 'visible' : ''}`}
        >
          {word}
        </span>
      ))}
    </div>
  );
};

export default RotatingWords;